// extracted by mini-css-extract-plugin
export default {"ErrorsList":"ErrorsList--jSuQE","item":"item--GSKYq","title":"title--chkhK","icon":"icon--jrKbr","text":"text--DZESw"};